var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWikiJnPayBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 17,
    viewBox: "0 0 30 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 16.2857,
    rx: 2.25,
    fill: "#FF6900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6622 6.31362V6.28962C11.6622 4.57362 10.4502 3.38562 8.44616 3.38562H5.01416V11.7856H6.86216V9.26562H8.26616C10.1502 9.26562 11.6622 8.25762 11.6622 6.31362ZM9.79016 6.34962C9.79016 7.06962 9.25016 7.62162 8.32616 7.62162H6.86216V5.05362H8.29016C9.21416 5.05362 9.79016 5.49762 9.79016 6.32562V6.34962Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2526 11.7856V8.05362C18.2526 6.31362 17.3766 5.28162 15.3846 5.28162C14.2926 5.28162 13.5966 5.48562 12.8886 5.79762L13.3446 7.18962C13.9326 6.97362 14.4246 6.84162 15.1206 6.84162C16.0326 6.84162 16.5006 7.26162 16.5006 8.01762V8.12562C16.0446 7.96962 15.5766 7.86162 14.9286 7.86162C13.4046 7.86162 12.3366 8.50962 12.3366 9.91362V9.93762C12.3366 11.2096 13.3326 11.9056 14.5446 11.9056C15.4326 11.9056 16.0446 11.5816 16.4886 11.0896V11.7856H18.2526ZM16.5246 9.51762C16.5246 10.1776 15.9486 10.6456 15.0966 10.6456C14.5086 10.6456 14.1006 10.3576 14.1006 9.86562V9.84162C14.1006 9.26562 14.5806 8.95362 15.3606 8.95362C15.8046 8.95362 16.2126 9.04962 16.5246 9.19362V9.51762Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7078 5.35362H23.8118L22.4078 9.73362L20.9438 5.35362H19.0118L21.5318 11.8096C21.3758 12.1336 21.2078 12.2296 20.8958 12.2296C20.6558 12.2296 20.3558 12.1216 20.1158 11.9776L19.5038 13.2976C19.9718 13.5736 20.4638 13.7416 21.1238 13.7416C22.2158 13.7416 22.7438 13.2496 23.2358 11.9416L25.7078 5.35362Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiJnPayBadge);
export default __webpack_public_path__ + "static/media/wiki-jnPay-badge.e54f49235408543d202506500d46858b.svg";
export { ForwardRef as ReactComponent };